/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Select, MenuItem, FormControl, FormHelperText, Typography, TextField, InputLabel, Divider } from '@material-ui/core'


const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({
    input_size: {
        fontSize : 1
    },

    head_cell : {
        paddingBottom : 0
    }
})

const filter_Steps = [5, 10, 15, 20, 25]

class Filter extends Component {
    state = {
        direction : "Top",
        count : 25,
        range : [0, 0]
    }

    stateChange = (key, value) => {
        this.setState({...this.state, [key] : value})
    }

    updateDirection = (direction, value) => {
        let group_filter = this.props.group_filter

        if (direction === "All") {
            group_filter.direction = 'All'
            group_filter.count = null
            group_filter.range.lower = 0
            group_filter.range.upper = this.getGroupCount()
        }

        if (direction === 'Top') {
            group_filter.direction = 'Top'
            group_filter.count = this.getGroupCount() > 5 ? 5 : this.getGroupCount()
            group_filter.range.lower = 0
            group_filter.range.upper = this.getGroupCount() > 5 ? 5 : this.getGroupCount()
        }

        if (direction === 'Bottom') {
            group_filter.direction = 'Bottom'
            group_filter.count = this.getGroupCount() > 5 ? 5 : this.getGroupCount()
            group_filter.range.lower = this.getGroupCount() > 5 ? this.getGroupCount() - 5 : 0
            group_filter.range.upper = this.getGroupCount()
        }

        if (direction === 'Range') {
            group_filter.direction = 'Range'
            group_filter.count = null
            group_filter.range.lower = 0
            group_filter.range.upper = this.getGroupCount() > 5 ? 5 : 0
        }

        if (direction === 'Random') {
            group_filter.direction = 'Random'
            group_filter.count = this.getGroupCount() > 5 ? 5 : 0
            group_filter.range.lower = null
            group_filter.range.upper = this.getGroupCount() > 5 ? 5 : 0
        }

        this.props.update_filter(group_filter,this.props.key)
    }

    updateCount = (value) => {
        let group_filter = this.props.group_filter
        console.log(group_filter)
        if(group_filter.direction === 'Top' || group_filter.direction === 'Random') {
            group_filter.range.lower = 0
            group_filter.range.upper = (value > this.getGroupCount()) ? this.getGroupCount() : value
            group_filter.count = value
            this.props.update_filter(group_filter,this.props.key)
        } else if(group_filter.direction === 'Bottom') {
            group_filter.direction = "Bottom"
            group_filter.range.lower = (value > this.getGroupCount()) ? 0 : this.getGroupCount() - value
            group_filter.range.upper = this.getGroupCount()
            group_filter.count = value
            this.props.update_filter(group_filter,this.props.key)
        }
        console.log(group_filter)
    }

    updateSort = (sort) => {
        let group_filter = this.props.group_filter
        group_filter.sort_by = sort
        this.props.update_filter(group_filter,this.props.key)
    }

    updateRangeLower = (value) => {
        let group_filter = this.props.group_filter
        if (Number(value) < (this.getGroupCount() - 5)) {
            group_filter.range.lower = Number(value)
            group_filter.range.upper = Number(value)
        }
        this.props.update_filter(group_filter,this.props.key)
    }

    updateRangeUpper = (value) => {
        let group_filter = this.props.group_filter
        group_filter.range.upper = Number(value)
        this.props.update_filter(group_filter,this.props.key)
    }

    getGroupCount = () => {
        return this.props.report_info ? this.props.report_info.report_summary[this.props.count_field].value : this.props.group_filter.total_count
    }

    renderFilterDirection = () => {
        const { classes } = this.props
        return (
            <FormControl variant = 'standard' size = 'small'>
                <Select 
                    value = {this.props.group_filter.direction} 
                    onChange = {(event) => this.updateDirection(event.target.value)}
                    inputProps = {{
                        classes : {
                            input : classes.input_size
                        }
                    }}
                >
                    <MenuItem 
                        disabled = {this.getGroupCount() > 50}
                        value = "All"
                    >All</MenuItem>
                    <MenuItem 
                        disabled = {this.getGroupCount() <= 5}
                        value = "Top"
                    >Top</MenuItem>
                    <MenuItem 
                        disabled = {this.getGroupCount() <= 5}
                        value = "Bottom"
                    >Bottom</MenuItem>
                    <MenuItem 
                        disabled = {this.getGroupCount() <= 5}
                        value = "Range"
                    >Range</MenuItem>
                    {this.props.location === 'GroupSpace' && <MenuItem 
                        disabled = {this.getGroupCount() <= 5}
                        value = "Random"
                    >Random</MenuItem>}
                </Select>   
            </FormControl>
        )
    }

    renderFilterParam = () => {
        if (this.props.group_filter.direction === 'All') {

        } else if (this.props.group_filter.direction === "Top" || this.props.group_filter.direction === "Bottom" || this.props.group_filter.direction === "Random" ) {
            return this.renderCount()
        } else {
            return this.renderRangeSelector()
        }
    }

    renderCount = () => {
        return (
            <FormControl style = {{marginLeft : '5px'}} variant = 'standard' size = 'small'>
                <Select 
                    value = {this.props.group_filter.count} 
                    onChange = {(event) => this.updateCount(event.target.value)}
                >
                    {filter_Steps.map(step => {
                        return (
                            <MenuItem 
                                value = {step}
                                disabled = {(this.props.group_filter.direction === "Top" || this.props.group_filter.direction === "Random") ? step > this.getGroupCount()+5 : this.props.group_filter.direction === "Bottom" ? (this.getGroupCount()+5 - step) < 0 : true}
                            >{step}</MenuItem>
                        )
                    })}
                </Select> 
            </FormControl>
        )
    }

    renderRangeSelector = () => {
        return(
            <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center', marginLeft: '5px'}}>
                <TextField 
                    style = {{width : '50%'}}
                    value = {this.props.group_filter.range.lower}
                    variant = 'standard'
                    size = 'small'
                    type = 'number'
                    helperText = "from"
                    onChange = {(event) => this.updateRangeLower(event.target.value)}
                />
                <FormControl style = {{marginLeft : '5px', width : '50%'}} variant = 'standard' size = 'small'>
                    {/* <InputLabel style = {{backgroundColor : '#F5F5F5'}}>to rank</InputLabel> */}
                    <Select
                        value = {this.props.group_filter.range.upper}
                        onChange = {(event) => this.updateRangeUpper(event.target.value)}
                    >
                        {filter_Steps.map(step => {
                            return(
                                <MenuItem 
                                    value = {this.props.group_filter.range.lower + step}
                                    disabled = {(this.props.group_filter.range.lower + step) > this.getGroupCount()}
                                >{this.props.group_filter.range.lower + step}</MenuItem>
                            )
                        })}
                    </Select>
                    <FormHelperText>to</FormHelperText>
                </FormControl>
            </div>
        )
    }

    renderSortBy = () => {
        console.log("IFC :: Sorting Props : ", this.props.sort_by)
        return (
            <FormControl style = {{marginLeft : '5px'}} variant = 'standard' size = 'small'>
                <Select 
                    value = {this.props.group_filter.sort_by} 
                    onChange = {(event) => this.updateSort(event.target.value)}
                >
                    {this.props.sort_by.map(sort_by => {
                        return (
                            <MenuItem 
                                value = {sort_by.value}
                            >{sort_by.annot}</MenuItem>
                        )
                    })}
                </Select> 
                <FormHelperText>Sorted By</FormHelperText>
            </FormControl>
        )
    }

    render() { 
        console.log("filter : ", this.props.group_filter)
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style={{width : '100%', display : 'flex', flexDirection : 'row', marginTop : '5px', marginLeft : '25px'}}>
                    <div>
                        <Typography style = {{width : '10%', marginTop : '5px'}} variant = 'subtitle2' color = 'textPrimary'> Showing: </Typography>
                    </div>
                    <div style = {{width : '80%', display : 'flex', flexDirection : 'row', marginLeft : '5px'}}>
                        {this.renderFilterDirection()}
                        {this.renderFilterParam()}
                        {this.props.sort_by && this.props.group_filter.direction !== "Random" && this.renderSortBy()}
                    </div>
                </div>    
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(Filter);